import { supabase } from "../client/client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import Layout from "./Layout";
import Loading from "./Loading";

function PerfilPage() {
  const [loading, setLoading]     = useState(true);
  const [processArea, setProcessArea] = useState([]);
  const [userData, setUserData]   = useState(null);
  const { getSessionAuth }        = useLogin();
  const navigate                  = useNavigate();

  useEffect(() => {
    const sessionAuth = async () => {
      const session = await getSessionAuth();
      if (session) {
        await getUser(session.id);
        setLoading(false);
      } else {
        navigate("/", { replace: true });
      }
    };
    sessionAuth();
  }, []);

  useEffect(() => {
    if (userData !== null) fetchProcess();
  }, [userData]);

  const getUser = async (id) => {
    const { error, data } = await supabase
      .from("users")
      .select()
      .eq("id", id)
      .single();
    if (error) throw error.message;
    setUserData(data);
  };

  async function fetchProcess() {
    try {
      if (!userData) return;
      const { data, error } = await supabase
        .from("area_users")
        .select("id_area, areas(name)")
        .eq("id_user", userData.id);
      if (error) { console.error("Error fetching areas:", error.message); return; }
      if (data.length === 0) return;
      setProcessArea(data.map((item) => item.areas.name));
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  }

  return (
    <Layout>
      {loading && <Loading />}

      <div className="mb-8">
        <p className="text-[#4691A6] font-semibold text-sm uppercase tracking-wide">Mi cuenta</p>
        <h1 className="text-gray-800 font-bold text-3xl mt-1">
          {userData?.name || "—"}
        </h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
        <div className="bg-white rounded-xl border border-gray-200 p-5">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Correo electrónico</p>
          <p className="text-gray-800 font-medium">{userData?.email || "—"}</p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-5">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Cargo</p>
          <p className="text-gray-800 font-medium">{userData?.charge || "—"}</p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-5">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Rol</p>
          <span className={`inline-block text-xs font-semibold px-3 py-1 rounded-full ${
            userData?.role === "admin"
              ? "bg-teal-100 text-teal-700"
              : "bg-gray-100 text-gray-600"
          }`}>
            {userData?.role || "—"}
          </span>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-5">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Áreas asignadas</p>
          {processArea.length > 0 ? (
            <div className="flex flex-wrap gap-2 mt-1">
              {processArea.map((area) => (
                <span key={area} className="text-xs bg-[#356674]/10 text-[#356674] font-semibold px-3 py-1 rounded-full">
                  {area}
                </span>
              ))}
            </div>
          ) : (
            <p className="text-gray-400 text-sm">Sin áreas asignadas</p>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default PerfilPage;
